import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=b0d1bc04&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"
import style0 from "./voucher.vue?vue&type=style&index=0&id=b0d1bc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d1bc04",
  null
  
)

export default component.exports